export default __webpack_public_path__ + "static/media/mashed_potato.15224dbe.png";